import { type ProbeResponse, parseLinkIdFromPath } from '@smart-link/shared';
import { getAdClickIds } from './ad-click-ids';
import { trackEvent } from './events';
import { postTelemetryJson } from './http';
import { sessionId } from './session';

let probeResult: ProbeResponse | null = null;
let probePromise: Promise<ProbeResponse | null> | null = null;

export function getLinkId(): string | undefined {
  return parseLinkIdFromPath(window.location.pathname);
}

export function startProbe(): Promise<ProbeResponse | null> {
  if (probePromise) return probePromise;

  probePromise = (async () => {
    try {
      trackEvent('probeRequested');
      const payload = {
        sessionId,
        linkId: getLinkId(),
        ...getAdClickIds(),
        pageHref: window.location.href,
        referer: document.referrer || undefined,
      };
      const res = await postTelemetryJson('/api/probe', payload);
      if (!res.ok) return null;
      probeResult = (await res.json()) as ProbeResponse;
      trackEvent('probeDone', {
        country: probeResult.detectedCountry,
      });
      return probeResult;
    } catch {
      return null;
    }
  })();

  return probePromise;
}

export function getProbeResult(): ProbeResponse | null {
  return probeResult;
}
